<!--  -->
<template>
  <user-center-wrap>
    <div class="center-anchor-up">直播间设置</div>
  </user-center-wrap>
</template>

<script>
import UserCenterWrap from "../../components/user-center-wrap/user-center-wrap";
import { post } from "@/util/http";

export default {
name: "live-room-settings",
components: {UserCenterWrap},
data() {
//这里存放数据
return {
};
},
created() {},
mounted() {},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
},
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.center-anchor-up {
  background-color: #fff;
  flex: 1;
  }
</style>